// extracted by mini-css-extract-plugin
export var container = "index-module--container--IE2Sr";
export var description = "index-module--description--oHtPs";